export default "__VITE_ASSET__fa7500cf__"